import {
  GET_TRIBUN_TERM_OF_USE_REQUEST,
  GET_TRIBUN_TERM_OF_USE_SUCCESS,
  GET_TRIBUN_TERM_OF_USE_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_TERM_OF_USE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_TERM_OF_USE_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_TRIBUN_TERM_OF_USE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
